module.exports = __webpack_public_path__ + "static/img/businessCooperation_banner_01.7eb117f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/businessCooperation_banner_01.png
// module id = Xydi
// module chunks = 0